/** Blinkl / WebAR backend (same default as minimal_client rollup.config.js). */
export const BLINKL_BACKEND_URL =
  process.env.REACT_APP_BLINKL_BACKEND_URL || 'https://admin.fanar.zone';

export const BLINKL_SLAM_CORE =
  process.env.REACT_APP_BLINKL_SLAM_CORE || '/slam_core/';

/**
 * Base URL for libbatar.wasm (no trailing slash).
 * webar_ts appends "/libbatar.wasm"; a trailing slash on the base yields "//libbatar.wasm".
 */
export function getBlinklWasmBaseUrl() {
  const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/+$/, '');
  if (!publicUrl || publicUrl === '/') {
    return window.location.origin;
  }
  const path = publicUrl.startsWith('/') ? publicUrl : `/${publicUrl}`;
  return `${window.location.origin}${path}`;
}
